import { Redirect } from "react-router";
import {
    useHistory,
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useParams,
    useRouteMatch,
} from "react-router-dom";
import LoginPage from "../pages/LoginPage";
import Register from "../pages/RegisterPage";
import VerifyNewUserPage from "../pages/VerifyNewUserPage";
import ConfirmationPage from "../pages/ConfirmationPage";
import ForgotPasswordPage from "../pages/ForgotPasswordPage";
import ResetPasswordLoginPage from "../pages/ResetPasswordLoginPage";
import ResetPasswordPage from "../pages/ResetPasswordPage";
import TylerLoginPage from "../pages/TylerLoginPage";
import TylerRegister from "../pages/TylerRegisterPage";

export default function UnAuthLayout() {
    const history = useHistory();
    const pathname = window.location.pathname;
    if (pathname === "/") history.push("/login");

    return (
        <Switch>
            <Route path="/verify">
                <VerifyNewUserPage />
            </Route>
            <Route path="/login">
                <LoginPage />
            </Route>
            <Route path="/signup/:id">
                <Register />
            </Route>
            <Route path="/register-success">
                <ConfirmationPage />
            </Route>
            <Route path="/new-password-login">
                <ResetPasswordLoginPage />
            </Route>
            <Route path="/forgot-password">
                <ForgotPasswordPage />
            </Route>
            <Route path="/reset-password">
                <ResetPasswordPage />
            </Route>
            <Route path="/tyler/login">
                <TylerLoginPage />
            </Route>
            <Route path="/tyler/register">
                <TylerRegister />
            </Route>
            <Route path="/">
                <Redirect to="/login" />
            </Route>
        </Switch>
    );
}
